import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import UrgentAppealForm from './urgent-appeal-form/UrgentAppealForm';
import LoadingContainer from 'components/common/LoadingContainer';
import { useMemo } from 'react';
import { useUrgentAppeal, useUpdateUrgentAppeal } from 'hooks/useUrgentAppeals';
import useUpload from 'hooks/useUpload';

function EditUrgentAppeal() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { urgentAppeal, isLoading: dataLoading } = useUrgentAppeal(id);
  const { updateUrgentAppealAsync, isUpdating } = useUpdateUrgentAppeal();
  const { upload, loading: uploadLoading } = useUpload();

  const onSubmit = async data => {
    let image = data.images;
    try {
      if (image && typeof image !== 'string') {
        const profileUrl = await upload(image);
        image = profileUrl;
      }
    } catch (e) {
      toast.error('Something went wrong! Please Try again later!');
      return;
    }
    try {
      await updateUrgentAppealAsync({
        id,
        data: {
          ...data,
          images: { primary: image }
        }
      });
      navigate(paths.urgentAppeals);
    } catch (error) {
      console.error(error);
    }
  };

  const initialValues = useMemo(() => {
    if (urgentAppeal) {
      const { title, targeted_amount, package_id, images, description } =
        urgentAppeal;
      return {
        title,
        targetAmount: targeted_amount,
        packageId: package_id,
        images: images?.primary || '',
        description
      };
    }
    return {};
  }, [urgentAppeal]);

  return dataLoading ? (
    <LoadingContainer />
  ) : (
    <UrgentAppealForm
      onSubmit={onSubmit}
      loading={isUpdating || uploadLoading}
      isEdit
      initialValues={initialValues}
    />
  );
}

export default EditUrgentAppeal;
